import DiscordChatbotSetup from '@components/chatbots/discord-chatbot-setup.jsx';
import { chatbots } from '@data/chatbots.js';
import CommandTable from '@components/shared/command-table.jsx';

export default function DiscordChatbotPage() {
  const connectURL = chatbots.discord.connectURL;

  const commands = [
    {
      command: '/sjsetup',
      description:
        'Enter your Tiltify donation url to connect the chatbot to your campaign',
    },
    {
      command: '/sjstatus',
      description:
        'Confirms if your chatbot is connected to your Tiltify campaign',
    },
    {
      command: '/sjcommands',
      description:
        'For a full list of chatbot commands go to https://www.stjude.org/discordbot',
    },
    {
      command: ['/sjraised', '/sjgoal'],
      description:
        'Our community has raised [raised amount] for the kids of St. Jude! Help us reach our fundraising goal of [goal amount] by donating here: [campaign donation url]',
    },
    {
      command: '/sjdonate',
      description:
        "I am raising money for the kids of St. Jude Children's Research Hospital. Help me reach my goal by donating now at [campaign's donation url]",
    },
    {
      command: '/sjmilestones',
      description:
        "Help unlock our St. Jude campaign milestones! [list of milestones] Donate now: [campaign's donation url]",
    },
    {
      command: '/sjnextmilestone',
      description:
        'My next St. Jude campaign milestone at: [milestone dollar amount] will be to [milestone text]. Let’s go!',
    },
    {
      command: '/sjpolls',
      description:
        "Check out our active St. Jude campaign polls! [list of active polls] Donate now to place your vote: [campaign's donation url]",
    },
    {
      command: '/sjrecent',
      description:
        "Thank you to these amazing recent donors for supporting St. Jude kids! Want to join in support? Donate here: [campaign's donation url]",
    },
    {
      command: '/prizeseasontotal',
      description:
        'Together with the entire St. Jude PLAY LIVE community, we have raised [total amout raised through St. Jude PLAY LIVE] for the kids of St. Jude!',
    },
    {
      command: '/creativetotal',
      description:
        'Together with the entire St. Jude PLAY LIVE Creative Season community, we have raised [total amount raised through St. Jude PLAY LIVE Creative Season] for the kids of St. Jude!',
    },
    {
      command: '/gcxtotal',
      description:
        'Together with the entire GCX community, we have raised [total amount raised through GCX event] for the kids of St. Jude!',
    },
    {
      command: '/sjteamtotal',
      description:
        'Our team has raised [raised amount] for the kids of St. Jude! Help us reach our team goal of [goal amount] for the kids of St. Jude by donating here: [team donate link]',
    },
    {
      command: '/sjteamreg',
      description:
        'Want to join our team in supporting the kids of St. Jude? Register here: [Tiltify team landing page for registration]',
    },
    {
      command: '/sjfact',
      description:
        "Chatbot will post random facts about St. Jude Children's Research Hospital",
    },
    {
      command: '/sjstory',
      description:
        "St. Jude Inspire tells the stories of St. Jude Children's Research Hospital to inspire trust, hope and faith in the mission that drives us: Finding cures. Saving children. Learn more about St. Jude patients, families and supporters at https://stjude.org/inspire!",
    },
    {
      command: '/sjgiftshop',
      description:
        'Support the kids of St. Jude with a unique gift from our online St. Jude Gift Shop! Shop here: https://giftshop.stjude.org/',
    },
    {
      command: '/sjmatching',
      description:
        'Looking for an easy way to double or even triple your donation to St. Jude? Ask your employer if they will match your donation to St. Jude. Visit: https://www.stjude.org/SJPLmatch or email matchinggifts@stjude.org for more info.',
    },
    {
      command: '/sjdono',
      description:
        'Choose an amount to show the impact of your donation to St. Jude',
    },
    {
      command: '/sjdiscord',
      description:
        'Check out the official St. Jude PLAY LIVE Discord to meet other fundraisers, ask questions, chat with staff and brainstorm ideas. Join us! http://discord.gg/stjudeplaylive',
    },
  ];

  return (
    <>
      <DiscordChatbotSetup connectURL={connectURL} />

      <div>
        <h2 className="text-2xl mb-4" id="commands">
          Commands
        </h2>
        <CommandTable commands={commands} />
      </div>
    </>
  );
}
